module.exports = __webpack_public_path__ + "img/premium-text.cc89debf.png";